<template>
  <!-- 河川予警報情報 -->
  <v-col class="rw-box-info mt-2">
    <!-- 見出し -->
    <v-col
      v-if="
        selectedRwDetailRwFlg &&
          (selectedWarnType === 10 ||
            selectedWarnType === 11 ||
            selectedWarnType === 20)
      "
      class="rw-info-header pl-4 py-2"
    >
      <div>
        {{ selectedRwDetailRw.heading }}
      </div>
    </v-col>
    <!-- ダム放流通知は見出しの部分に観測所名を表示 -->
    <div v-if="selectedWarnType === 30" class="rw-dam-header ">
      <div class="rw-box-dam-name px-4 pb-2">
        <div class="rw-obs-name-kana ">
          {{ selectedRwDetailMt.obsKana }}
        </div>
        <div class="rw-obs-name ">
          {{ selectedRwDetailMt.obsNm }}
        </div>
      </div>
      <v-btn
        class="ml-2"
        color="success"
        outlined
        small
        @click="
          clickObs(
            selectedRwDetailMt.ofcCd,
            selectedRwDetailMt.itmkndCd,
            selectedRwDetailMt.obsCd
          )
        "
        >{{ text.btnToDamobs }}</v-btn
      >
    </div>

    <!-- 水系名 区間名 -->
    <v-row v-if="selectedRwDetailMt">
      <v-col class="pl-8">
        <div class="name_kana">
          <span>{{ selectedRwDetailMt.rsysKana }}</span>
        </div>
        <div class="name">
          <span>{{ selectedRwDetailMt.rsysNm }}水系</span>
        </div>
      </v-col>
      <v-col class="pl-8">
        <div class="name_kana">
          <span v-if="selectedWarnType === 10">{{
            selectedRwDetailMt.fldfrKana
          }}</span>
          <span v-if="selectedWarnType === 11">{{
            selectedRwDetailMt.evstgKana
          }}</span>
          <span v-if="selectedWarnType === 20">{{
            selectedRwDetailMt.fldctlKana
          }}</span>
          <span v-if="selectedWarnType === 30">{{
            selectedRwDetailMt.rvrKana
          }}</span>
        </div>
        <div class="name">
          <span v-if="selectedWarnType === 10">{{
            selectedRwDetailMt.fldfrNm
          }}</span>
          <span v-if="selectedWarnType === 11">{{
            selectedRwDetailMt.evstgNm
          }}</span>
          <span v-if="selectedWarnType === 20">{{
            selectedRwDetailMt.fldctlNm
          }}</span>
          <span v-if="selectedWarnType === 30">{{
            selectedRwDetailMt.rvrNm
          }}</span>
        </div>
      </v-col>
    </v-row>
    <!-- 発表状況 -->
    <v-col class="rw-state-line pt-0 pd-0">
      <v-card>
        <div class="rw-state-header">
          発表状況
          <!-- 凡例 -->
          <v-tooltip
            v-if="
              (selectedWarnType === 30 &&
                config.messageConfig.legendMsg.damdsch.damdschJudge) ||
                (selectedWarnType === 20 &&
                  config.messageConfig.legendMsg.fldctl.fldctlJudge)
            "
            bottom
            max-width="350"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="dimgray" class="ml-1 pb-1"
                >help_outline</v-icon
              >
            </template>
            <!-- <span v-if="selectedWarnType === 10 || selectedWarnType === 11">
              <span>
                {{ config.messageConfig.legendMsg.fldfr.fldfrMsg1 }}
                <br />
                {{ config.messageConfig.legendMsg.fldfr.fldfrMsg2 }}
                <br />
              </span>
              <img
                class="rw-legend-img"
                :src="config.messageConfig.legendMsg.fldfr.img"
              />
            </span> -->
            <span v-if="selectedWarnType === 30">
              {{ config.messageConfig.legendMsg.damdsch.damdschMsg1 }}
              <br />
              <span class="text-damdsch-disasteroperating rw-span-warn mb-1">
                {{
                  config.messageConfig.legendMsg.damdsch.disasteroperating
                }}</span
              >
              <br />
              <span class="text-damdsch-riserving rw-span-warn">
                {{ config.messageConfig.legendMsg.damdsch.riserving }}
              </span>
            </span>
            <span v-if="selectedWarnType === 20">
              {{ config.messageConfig.legendMsg.fldctl.fldctlMsg1 }}
              <br />
              {{ config.messageConfig.legendMsg.fldctl.fldctlMsg2 }}
              <br />
              <span class="text-fldctl-dispatch rw-span-warn mb-1">
                {{ config.messageConfig.legendMsg.fldctl.dispatch }}
              </span>
              <br />
              <span class="text-fldctl-preparation rw-span-warn mb-1">
                {{ config.messageConfig.legendMsg.fldctl.preparation }}
              </span>
              <br />
              <span class="text-fldctl-standby rw-span-warn">
                {{ config.messageConfig.legendMsg.fldctl.standby }}
              </span>
            </span>
          </v-tooltip>
        </div>
        <!-- 洪水予報 -->
        <div
          v-if="selectedRwDetailRwFlg && selectedWarnType === 10"
          class="rw-state-value"
          :class="{
            'text-flood-occurrence': selectedRwDetailRw.fldfrLvl === 90,
            'text-flood-danger': selectedRwDetailRw.fldfrLvl === 80,
            'text-flood-refuge': selectedRwDetailRw.fldfrLvl === 60,
            'text-flood-warn': selectedRwDetailRw.fldfrLvl === 30,
            'text-flood-normal': selectedRwDetailRw.fldfrLvl === 0,
          }"
        >
          <v-row class="rw-state-row ma-0">
            <!-- 前ボタンを非表示 -->
            <!-- <div class="rw-state-prev pl-1">
              <v-btn
                v-if="isDispPrev"
                depressed
                fab
                x-small
                @click="prevAnnIdx"
              >
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </div> -->
            <div class="rw-state-text">
              <div>
                第{{ selectedRwDetailRw.annNo }}号
                {{ selectedRwDetailRw.fldfrKndNmM }}
                <span v-if="selectedRwDetailRw.fldfrLvl === 30">
                  {{ config.messageConfig.alertLvl.fldfrLvl2 }}
                </span>
                <span v-if="selectedRwDetailRw.fldfrLvl === 60">
                  {{ config.messageConfig.alertLvl.fldfrLvl3 }}
                </span>
                <span v-if="selectedRwDetailRw.fldfrLvl === 80">
                  {{ config.messageConfig.alertLvl.fldfrLvl4 }}
                </span>
                <span v-if="selectedRwDetailRw.fldfrLvl === 90">
                  {{ config.messageConfig.alertLvl.fldfrLvl5 }}
                </span>
              </div>
              <div>{{ selectedRwDetailRw.annTime }}</div>
            </div>
            <!-- 次へボタンを非表示 -->
            <!-- <div class="rw-state-next mr-1">
              <v-btn
                v-if="isDispNext"
                depressed
                fab
                x-small
                @click="nextAnnIdx"
              >
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </div> -->
          </v-row>
        </div>
        <!-- 未発表メッセージ -->
        <div
          v-if="!selectedRwDetailRwFlg && selectedWarnType === 10"
          class="rw-state-value text-flood-normal"
        >
          {{ text.fldfrAnnounce }}
        </div>
        <!-- 水位周知河川 -->
        <div
          v-if="selectedRwDetailRwFlg && selectedWarnType === 11"
          class="rw-state-value"
          :class="{
            'text-flood-occurrence': selectedRwDetailRw.evstgLvl === 90,
            'text-flood-danger': selectedRwDetailRw.evstgLvl === 80,
            'text-flood-refuge': selectedRwDetailRw.evstgLvl === 60,
            'text-flood-warn': selectedRwDetailRw.evstgLvl === 30,
            'text-flood-normal': selectedRwDetailRw.evstgLvl === 0,
          }"
        >
          <v-row class="rw-state-row ma-0">
            <!-- <div class="rw-state-prev pl-1">
              <v-btn
                v-if="isDispPrev"
                depressed
                fab
                x-small
                @click="prevAnnIdx"
              >
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </div> -->
            <div class="rw-state-text">
              <div>
                第{{ selectedRwDetailRw.annNo }}号
                {{ selectedRwDetailRw.evstgKndNmM }}
                <span v-if="selectedRwDetailRw.evstgLvl === 30">
                  {{ config.messageConfig.alertLvl.fldfrLvl2 }}
                </span>
                <span v-if="selectedRwDetailRw.evstgLvl === 60">
                  {{ config.messageConfig.alertLvl.fldfrLvl3 }}
                </span>
                <span v-if="selectedRwDetailRw.evstgLvl === 80">
                  {{ config.messageConfig.alertLvl.fldfrLvl4 }}
                </span>
                <span v-if="selectedRwDetailRw.evstgLvl === 90">
                  {{ config.messageConfig.alertLvl.fldfrLvl5 }}
                </span>
              </div>
              <div>{{ selectedRwDetailRw.annTime }}</div>
            </div>
            <!-- <div class="rw-state-next mr-1">
              <v-btn
                v-if="isDispNext"
                depressed
                fab
                x-small
                @click="nextAnnIdx"
              >
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </div> -->
          </v-row>
        </div>
        <!-- 未発表メッセージ -->
        <div
          v-if="!selectedRwDetailRwFlg && selectedWarnType === 11"
          class="rw-state-value text-flood-normal"
        >
          {{ text.evstgAnnounce }}
        </div>
        <!-- 水防警報 -->
        <div
          v-if="selectedRwDetailRwFlg && selectedWarnType === 20"
          class="rw-state-value"
          :class="{
            'text-fldctl-normal': selectedRwDetailRw.fldctlLvl === 0,
            'text-fldctl-standby': selectedRwDetailRw.fldctlLvl === 10,
            'text-fldctl-preparation': selectedRwDetailRw.fldctlLvl === 20,
            'text-fldctl-dispatch': selectedRwDetailRw.fldctlLvl === 40,
          }"
        >
          <v-row class="rw-state-row ma-0">
            <!-- <div class="rw-state-prev pl-1">
              <v-btn
                v-if="isDispPrev"
                depressed
                fab
                x-small
                @click="prevAnnIdx"
              >
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </div> -->
            <div class="rw-state-text">
              <div>
                第{{ selectedRwDetailRw.annNo }}号
                {{ selectedRwDetailRw.fldctlKndNm }}
              </div>
              <div>{{ selectedRwDetailRw.annTime }}</div>
            </div>
            <!-- <div class="rw-state-next mr-1">
              <v-btn
                v-if="isDispNext"
                depressed
                fab
                x-small
                @click="nextAnnIdx"
              >
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </div> -->
          </v-row>
        </div>
        <!-- 未発表メッセージ -->
        <div
          v-if="!selectedRwDetailRwFlg && selectedWarnType === 20"
          class="rw-state-value text-flood-normal"
        >
          {{ text.fldctlAnnounce }}
        </div>
        <!-- ダム放流通知 -->
        <div
          v-if="selectedRwDetailRwFlg && selectedWarnType === 30"
          class="rw-state-value"
          :class="{
            'text-damdsch-normal': selectedRwDetailRw.damdschLvl === 0,
            'text-damdsch-riserving': selectedRwDetailRw.damdschLvl === 50,
            'text-damdsch-disasteroperating':
              selectedRwDetailRw.damdschLvl === 70,
          }"
        >
          <v-row class="rw-state-row ma-0">
            <!-- <div class="rw-state-prev pl-1">
              <v-btn
                v-if="isDispPrev"
                depressed
                fab
                x-small
                @click="prevAnnIdx"
              >
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </div> -->
            <div class="rw-state-text">
              <div>
                第{{ selectedRwDetailRw.annNo }}号
                {{ selectedRwDetailRw.damdschKndNm }}
              </div>
              <div>{{ selectedRwDetailRw.annTime }}</div>
            </div>
            <!-- <div class="rw-state-next mr-1">
              <v-btn
                v-if="isDispNext"
                depressed
                fab
                x-small
                @click="nextAnnIdx"
              >
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </div> -->
          </v-row>
        </div>
        <!-- 未発表メッセージ -->
        <div
          v-if="!selectedRwDetailRwFlg && selectedWarnType === 30"
          class="rw-state-value text-flood-normal"
        >
          {{ text.damdschAnnounce }}
        </div>
        <!-- <div
          v-if="this.$store.state.RiverWarn.selectedAnnIdx !== 0"
          class="rw-state-footer"
        >
          <v-spacer></v-spacer>
          <span class="rw-state-header-state pr-2">{{ annState }}</span>
        </div> -->
      </v-card>
    </v-col>
  </v-col>
</template>
<script>
import mixin from "./../../lib/mixin.js";
export default {
  name: "rw-info",
  mixins: [mixin],
  data() {
    return {
      text: {
        fldfrAnnounce: "洪水予報は発表されていません",
        evstgAnnounce: "水位到達情報は発表されていません",
        damdschAnnounce: "ダム放流通知は発表されていません",
        fldctlAnnounce: "水防警報は発表されていません",
        btnToDamobs: "ダムを表示",
      },
    };
  },
  computed: {
    /** 最新・過去表示 */
    annState: {
      get() {
        if (this.$store.state.RiverWarn.selectedAnnIdx === 0) {
          return "";
        } else {
          return "最新の発表ではありません";
        }
      },
    },
    /** 戻るボタン表示有無 */
    isDispPrev: {
      get() {
        if (this.$store.state.RiverWarn.selectedAnnIdx === 0) {
          return false;
        } else {
          return true;
        }
      },
    },
    /** 次へボタン表示有無 */
    isDispNext: {
      get() {
        let maxIdx = this.$store.state.RiverWarn.selectedRwDetail.rw.length - 1;
        if (this.$store.state.RiverWarn.selectedAnnIdx === maxIdx) {
          return false;
        } else {
          return true;
        }
      },
    },
    /**
     * 選択中予警報種別
     */
    selectedWarnType: {
      get() {
        return this.$store.state.RiverWarn.selectedWarnType;
      },
    },
    /**
     * 選択中河川予警報詳細
     */
    selectedRwDetailRw: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rw[
          this.$store.state.RiverWarn.selectedAnnIdx
        ];
      },
    },
    /**
     * 選択中河川予警報マスタ
     */
    selectedRwDetailMt: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.mt;
      },
    },
    /**
     * 選択中河川予警報フラグ
     */
    selectedRwDetailRwFlg: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rwFlg;
      },
    },
    /**
     *  設定情報
     */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
  },
  methods: {
    /** 個別観測所画面へ遷移 */
    clickObs(ofcCd, itmkndCd, obsCd) {
      this.$log.debug(
        "[RwInfo] clickObs(" + ofcCd + "," + itmkndCd + "," + obsCd + ")"
      );
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: Number(ofcCd),
        itmkndCd: Number(itmkndCd),
        obsCd: Number(obsCd),
      });
      // 画面遷移
      this.routerPushTm("/pc/tm");
    },
    /** 前の号を表示 */
    prevAnnIdx() {
      this.$log.debug("[RwInfo] prevAnnIdx");
      let idx = this.$store.state.RiverWarn.selectedAnnIdx;
      this.$store.commit("RiverWarn/setSelectedAnnIdx", idx - 1);
    },
    /** 次の号を表示 */
    nextAnnIdx() {
      this.$log.debug("[RwInfo] nextAnnIdx");
      let idx = this.$store.state.RiverWarn.selectedAnnIdx;
      this.$store.commit("RiverWarn/setSelectedAnnIdx", idx + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.rw-header {
  display: flex;
  align-items: center;
}

.rw-box-info {
  width: 100%;
  padding: 0;
  margin: 0;
}

.rw-info-header {
  font-size: 1rem;
  font-weight: 600;
  border-bottom: solid lightgray 1px;
}

.rw-dam-header {
  font-size: 1rem;
  font-weight: 600;
  border-bottom: solid lightgray 1px;

  display: flex;
  flex-direction: row;
  align-items: center;

  .rw-box-dam-name {
    .rw-obs-name {
      letter-spacing: 0px;
      text-align: left;
      font-size: 1rem;
      font-weight: 500;
    }
    .rw-obs-name-kana {
      letter-spacing: 0px;
      text-align: left;
      font-size: 0.625rem;
      font-weight: 400;
    }
  }
}

.name_kana {
  letter-spacing: 0px;
  text-align: left;
  font-size: 0.625rem;
  font-weight: 400;
}

.name {
  letter-spacing: 0px;
  text-align: left;
  font-size: 1rem;
  font-weight: 500;
}
.rw-state-header {
  background-color: #dddddd;
  color: black;
  text-align: center;
  .rw-tab-guide-tip {
    z-index: 3510;
  }
  .rw-state-header-state {
    color: orange;
    font-weight: bold;
  }
}
.rw-state-value {
  text-align: center;
  word-wrap: break-word;

  .rw-state-row {
    display: flex;

    .rw-state-prev {
      display: flex;
      align-items: center;
      width: 40px;
    }

    .rw-state-next {
      display: flex;
      align-items: center;
      width: 40px;
    }

    .rw-state-text {
      flex: 1;
      text-align: center;
      word-wrap: break-word;
    }
  }
}

.rw-state-footer {
  display: flex;
  justify-self: flex-end;
  .rw-state-header-state {
    color: orange;
    font-weight: bold;
  }
}

.rw-state-line {
  border-bottom: solid lightgray 1px;
}
.rw-span-warn {
  font-size: 10pt;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border-radius: 4px;
}

.rw-legend-img {
  width: 100%;
}
</style>
